import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import HomeOverview from "@/pages/HomeOverview";
import ProcessOrchestration from "@/pages/ProcessOrchestration";
import AIInsights from "@/pages/AIInsights";
import SimulationLab from "@/pages/SimulationLab";
import Reports from "@/pages/Reports";
import Administration from "@/pages/Administration";
import MediaLibrary from "@/pages/MediaLibrary";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="grain min-h-screen flex items-center justify-center">
        <div className="text-sm data-label">Initializing ITSME…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route index element={<HomeOverview />} />
        <Route path="processes" element={<ProcessOrchestration />} />
        <Route path="insights" element={<AIInsights />} />
        <Route path="simulation" element={<SimulationLab />} />
        <Route path="reports" element={<Reports />} />
        <Route path="media" element={<MediaLibrary />} />
        <Route path="admin" element={<Administration />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" duration={2500} closeButton richColors={false}
                 offset={72} />
      </AuthProvider>
    </div>
  );
}
